<app-search></app-search>
<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      <h1 class="title">Lista de versiones</h1>
    </div>
    <br />
    <div class="card-header">
      <button id="" class="primary-button" appPermision="/changelog+c" (click)="createChangelog()">
        <span class="button-content"> <mat-icon>add_circle</mat-icon> Agregar nuevo </span>
      </button>
    </div>
    <br />
    <div class="table-scroll-wrapper">
      <section class="table-container mat-elevation-z1" tabindex="0">
        <div class="table-adjustable">
          <table
            mat-table
            [dataSource]="
              (asyncChangelog | async) ?? []
                | paginate
                  : {
                      id: 'server',
                      itemsPerPage: limit,
                      currentPage: page,
                      totalItems: total,
                    }
            "
          >
            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let changelog">
                <a mat-icon-a [matMenuTriggerFor]="menu" aria-label="Acciones" title="Acciones">
                  <mat-icon class="main-icon">menu</mat-icon>
                </a>
                <mat-menu #menu="matMenu" class="icon-menu">
                  <!-- Editar -->
                  <button
                    class="icon-button"
                    mat-menu-item
                    appPermision="/changelog+u"
                    (click)="updateChangelog(changelog)"
                  >
                    <span class="text-span"
                      ><mat-icon class="icon-size">edit</mat-icon>Editar
                    </span
                    >
                  </button>
                  <mat-divider></mat-divider>
                  <!-- Eliminar -->
                  <button
                    class="icon-button"
                    mat-menu-item
                    appOnlysuperuser="/changelog/:id"
                    (click)="eliminate(changelog.id)"
                  >
                    <span class="text-span delete-span"
                      ><mat-icon class="icon-size delete-icon">delete</mat-icon>Eliminar
                    </span
                    >
                  </button>
                </mat-menu>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let changelog">
                {{ changelog.id }}
              </td>
            </ng-container>

            <ng-container matColumnDef="version">
              <th mat-header-cell *matHeaderCellDef>Versiones</th>
              <td mat-cell *matCellDef="let changelog">
                {{ changelog.version }}
              </td>
            </ng-container>

            <ng-container matColumnDef="featureDesc">
              <th mat-header-cell *matHeaderCellDef>Mejoras implementadas</th>
              <td mat-cell *matCellDef="let changelog">
                {{ changelog.featureDesc }}
              </td>
            </ng-container>

            <ng-container matColumnDef="bugFixesDesc">
              <th mat-header-cell *matHeaderCellDef>Errorres corregidos</th>
              <td mat-cell *matCellDef="let changelog">
                {{ changelog.bugFixesDesc }}
              </td>
            </ng-container>

            <ng-container matColumnDef="releaseDate">
              <th mat-header-cell *matHeaderCellDef>Fecha de Lanzamiento</th>
              <td mat-cell *matCellDef="let changelog">
                {{ changelog.releaseDate }}
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: showColumns" class="highlight-row"></tr>
          </table>
        </div>
      </section>
    </div>
    <pagination-controls
      (pageChange)="fetchChangelog($event)"
      previousLabel="Anterior"
      nextLabel="Siguiente"
      id="server"
    ></pagination-controls>
  </div>
</div>
